import { Seo } from "@/components/Seo";
import { Reveal, PillButton } from "@/components/primitives";

export default function InvestorLogin() {
  return (
    <div className="glow-navy min-h-screen flex items-center justify-center px-6 py-32">
      <Seo title="Investor Log-In" description="Private investor access — Jennae Michelle Holdings." />
      <Reveal className="text-center max-w-md">
        <p className="font-display uppercase tracking-luxe text-xs text-[var(--muted)]">Jennae Michelle Holdings</p>
        <h1 className="mt-5 font-display gold-text uppercase tracking-wide2 text-2xl md:text-3xl">Investor Log-In</h1>
        <p className="mt-6 text-[var(--bone)]/80 leading-relaxed">
          Secure investor access is by invitation. Portfolio-wide single sign-on is being provisioned as part of the Holdings platform.
        </p>
        <p className="mt-3 font-display uppercase tracking-wide2 text-[10px] text-[var(--gold)]">Private Access Only</p>
        <div className="mt-10"><PillButton to="/contact" testid="investor-request-access">Request Access</PillButton></div>
      </Reveal>
    </div>
  );
}
